  <div class="checkbox">
  <label>
    <span [ngClass]="{'invalid': invalid | async, 'pt-0': textInTop }" class="infotext"><span *ngIf="required">* </span>{{ title }}</span>
    <input type="checkbox" [attr.name]="name" [(ngModel)]="value" (click)="onClick($event)" (change)="checkedChanged($event)">
    <div [ngClass]="{invalid: invalid | async }"></div>
  </label>
</div>
